import React from "react";
import dialog from "../../common/utility/dialog";
import formatoPdfService from "../../service/administracion/formatoPdfService";

import FormatosPDF from "../../assets/files/FormatosPDF.xlsx";


import {
  Form,
  Divider,
  PageHeader,
  Button,
  message,
  Input,
  Table,
  Empty,
  Select
} from "antd";
const { Option } = Select;
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listaFormato: [{ id: 1, nombre: 'A4' }],
      listaModelo: [
        { id: 1, nombre: 'Modelo 1' },
        { id: 2, nombre: 'Modelo 2' },
        { id: 3, nombre: 'Modelo 3' },
        { id: 4, nombre: 'Modelo 4' }
      ],

      tiposComprobante: [
        { identifier: '43frytry', idTipoComprobante: 2, nombre: "FACTURA", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'er433663', idTipoComprobante: 4, nombre: "BOLETA", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'vgbdr633', idTipoComprobante: 8, nombre: "NOTA DE CRÉDITO", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'do00etrt', idTipoComprobante: 9, nombre: "NOTA DE DÉBITO", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'qw243rrt', idTipoComprobante: 10, nombre: "GUÍA DE REMISIÓN - REMITENTE", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'vghju643', idTipoComprobante: 32, nombre: "GUÍA DE REMISIÓN - TRANSPORTISTA", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'hjuyu754', idTipoComprobante: 89, nombre: "COTIZACIÓN", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'fght4654', idTipoComprobante: 90, nombre: "NOTA DE PEDIDO", idTipoFormato: 1, formatoPDF: 1 },
        { identifier: 'fhjui855', idTipoComprobante: 97, nombre: "NOTA DE VENTA", idTipoFormato: 1, formatoPDF: 1 },

      ],
    };
  }

  handleDownload = (e) => {
    e.preventDefault();

    // Ruta del archivo en la carpeta public
    const fileUrl = FormatosPDF;
    const fileName = 'FormatosPDF.xlsx';

    // Crea un enlace invisible para descargar el archivo
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);

    // Dispara el click en el enlace
    link.click();

    // Elimina el enlace después de descargar
    document.body.removeChild(link);
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {

      console.log(values);
      if (!err) {
        const form = {
          jsonItem: this.fetchFormato(values)
        }

        dialog.confirm("¿Esta seguro de modificar la contraseña?", async () => {

          var response = await formatoPdfService.modificar(form);
          if (response.status === 200) {
            message.success('Modificado correctamente.');
            return;
          }

          if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
          }

          dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
      }
    });
  }

  fetchFormato = (values) => {
    var result = [];
    var keys = [];
    var obj = Object.assign({}, values.arridTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        IdTipoComprobante: values.arridTipoComprobante[key],
        IdTipoFormato: values.arrFormato[key].key,
        FormatoPDF: values.arrModelo[key].key,
        nombre: ''

      });
    });


    return JSON.stringify(result);
  };

  async componentDidMount() {

    const tiposComprobante = await formatoPdfService.listar();

    this.setState({
      loadingSource: false,
      tiposComprobante: tiposComprobante ? tiposComprobante : [],

    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <PageHeader
          title="Cambiar Formato de Impresión"
          extra={[

            <div style={{ width: '100%', textAlign: "right" }}>
              <div className="custom-options">
                <Button
                  icon="save"
                  type="primary"
                  ghost
                  onClick={this.handleOk}
                >
                  Guardar
                </Button>

                <Button
                  icon="download"
                  type="success"
                  ghost
                  onClick={this.handleDownload}
                >
                  Descargar
                </Button>
              </div>
            </div>
          ]}
        />
        <Divider />


        <div className="col-md-6 form-group">

          <Table
            className={'table-referencia'}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: 'auto' }}
            pagination={false}
            dataSource={this.state.tiposComprobante}
            rowKey={record => record.id}
            locale={{
              emptyText: <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description='Pulse el botón "+ Agregar".'
              />
            }}
            columns={[

              {
                title: 'Nombre',
                dataIndex: 'nombre',
                key: 'nombre',
                align: 'center',

              },
              {
                title: '',
                dataIndex: 'idTipoComprobante',
                key: 'idTipoComprobante',
                render: (value, row) => {
                  return (
                    <div>
                      {getFieldDecorator(`arridTipoComprobante[${row.identifier}]`, { initialValue: value })(
                        <Input hidden />
                      )}
                    </div>
                  );
                }
              },
              {
                title: 'Formato',
                dataIndex: 'idTipoFormato',
                key: 'idTipoFormato',
                render: (value, row) => {
                  return (
                    <Form.Item>
                      {getFieldDecorator(`arrFormato[${row.identifier}]`, {
                        initialValue: value ? { key: value } : undefined,
                        rules: [{
                          required: true,
                          message: 'Requerido'
                        }]
                      })(
                        <Select showSearch labelInValue
                          placeholder={"Seleccione Formato"}
                          optionFilterProp="children"
                        >
                          {this.state.listaFormato.map(item => (
                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                          ))}
                        </Select>

                      )}
                    </Form.Item>
                  );
                }
              },
              {
                title: 'Modelo',
                dataIndex: 'formatoPDF',
                key: 'formatoPDF',
                render: (value, row) => {
                  return (
                    <Form.Item>
                      {getFieldDecorator(`arrModelo[${row.identifier}]`, {
                        initialValue: value ? { key: value } : undefined,
                        rules: [{
                          required: true,
                          message: 'Requerido'
                        }]
                      })(
                        <Select showSearch labelInValue
                          placeholder={"Seleccione Modelo"}
                          optionFilterProp="children"
                        >
                          {this.state.listaModelo.map(item => (
                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  );
                }
              },

            ]}
          />

        </div>
      </div>
    );
  }
}

export default Form.create()(Index);
